<template>
  <div>
    <div @click="dialog = true" v-if="btn !== false">
      <slot />
    </div>
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-top-transition"
      persistent
    >
      <v-card>
        <v-toolbar dark color="primary" fixed class="sticky-top">
          <v-toolbar-title>
            <v-icon>mdi-car</v-icon>
            {{ $i18n.t("Select Expense(s)") }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon @click="dialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-card-text>
          <v-row>
            <v-col cols="12" md="2" sm="4">
              <v-text-field
                :label="$i18n.t('Invoice No')"
                class="purple-input"
                v-model="filter.invoiceNo"
              />
            </v-col>
            <v-col cols="12" sm="12" md="4" lg="3">
              <z-date-picker
                :label="$i18n.t('From Date')"
                v-model="filter.startDate"
              />
            </v-col>
            <v-col cols="12" sm="12" md="4" lg="3">
              <z-date-picker
                :label="$i18n.t('Till Date')"
                v-model="filter.endDate"
              />
            </v-col>

            <v-spacer />
            <v-col cols="12" md="2" sm="4" class="text-right pull-right my-3">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    class="mr-0"
                    color="black"
                    text
                    fab
                    x-small
                    @click="clearSearch()"
                    style="margin-right: 2px !important"
                    v-on="on"
                  >
                    <v-icon>mdi-cached</v-icon>
                  </v-btn>
                </template>
                <span>{{ $i18n.t("Clear Filter") }}</span>
              </v-tooltip>
              <v-btn
                color="success"
                class="mr-0"
                fab
                x-small
                dark
                @click="search()"
                :loading="loading"
              >
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
              <v-btn @click="proccedWithCehcked">Select</v-btn>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-text>
          <v-btn
            v-if="grid != undefined && !grid.records"
            class="text-center secondary--text pa-10"
            text
            color="primary"
            style="width: 100%"
            :loading="loading"
            >{{ $i18n.t("No records available") }}</v-btn
          >
          <v-row>
            <v-col cols="12" md="12" sm="12">
              <v-simple-table dense v-if="grid.records">
                <thead>
                  <tr>
                    <th class="primary--text">
                      <v-checkbox v-model="selectAll" />
                    </th>
                    <th class="primary--text">
                      {{ $i18n.t("Account") }}
                    </th>
                    <th class="primary--text">
                      {{ $i18n.t("Expense Type") }}
                    </th>
                    <th colspan="2" class="primary--text">
                      {{ $i18n.t("Vehicle") }}
                    </th>
                    <th colspan="2" class="primary--text">
                      {{ $i18n.t("Driver") }}
                    </th>
                    <th class="primary--text">{{ $i18n.t("Payment Date") }}</th>
                    <th class="primary--text">{{ $i18n.t("Affect From") }}</th>
                    <th class="primary--text">{{ $i18n.t("Title") }}</th>
                    <th class="primary--text">{{ $i18n.t("Fare") }}</th>
                  </tr>
                </thead>

                <tbody>
                  <tr v-for="expense in grid.rows" :key="expense._id">
                    <td>
                      <v-checkbox v-model="expense.selected" />
                    </td>
                    <td>{{ expense.accountName }}</td>
                    <td>{{ expense.expenseType }}</td>
                    <td>
                      {{ expense.vehicleTO ? expense.vehicleTO.regNo : "" }}
                    </td>
                    <td>
                      {{
                        expense.vehicleTO ? expense.vehicleTO.vehicleType : ""
                      }}
                    </td>

                    <td>
                      {{ expense.driverTO ? expense.driverTO.name : "" }}
                    </td>
                    <td>
                      {{ expense.driverTO ? expense.driverTO.countryCode : "" }}
                      {{ expense.driverTO ? expense.driverTO.phone : "" }}
                    </td>

                    <td>{{ formatDate(expense.date) }}</td>
                    <td>{{ formatDate(expense.affectFrom) }}</td>
                    <td>{{ expense.title }}</td>
                    <td>
                      <span v-if="expense.fare"
                        >{{ expense.fare.currency }}
                        {{ expense.fare.total }}</span
                      >
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
              <v-pagination
                v-if="grid.records"
                v-model="grid.page"
                class="my-4"
                :length="grid.total"
                total-visible="10"
                @input="showPage"
              ></v-pagination>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { doPost } from "@/store/common/module/apis";
import common from "@/store/common/module/common";
import Themeable from "vuetify/lib/mixins/themeable";
import { Vue, Component, Watch } from "vue-property-decorator";

@Component({
  name: "ExpenseSelect",
  props: {
    corp_id: {
      default: null,
    },
    client_id: {
      default: null,
    },
    supplier_id: {
      default: null,
    },
    value: {
      default: null,
    },
    idOnly: {
      default: false,
    },
    disabled: {
      default: false,
    },
    label: {
      default: "Expenses",
    },
    multiple: {
      default: false,
    },
    clearable: {
      default: false,
    },
    btn: {
      default: false,
    },
    prependIcon: {
      default: undefined,
    },
    prependInnerIcon: {
      default: undefined,
    },
    expenses: {
      default: undefined,
    },
    rules: {
      default: () => [],
    },
    selectedExpenses: {
      default: null,
    },
  },
})
export default class ExpenseSelect extends (Vue, Themeable) {
  grid = {};
  rows = 20;
  url = "/api/expense/grid/post?rows=";
  filter = {
    receiptNo: null,
    regNo: null,
    driverName: null,
    driverCC: null,
    driverPhone: null,
    startDate: null,
    endDate: null,
  };
  selectAll = false;
  on = null;
  page = 1;
  dialog = false;
  loading = false;

  @Watch("selectAll")
  onSelectAll() {
    if (this.grid && this.grid.rows) {
      for (let i = 0; i < this.grid.rows.length; i++) {
        this.grid.rows[i].selected = this.selectAll;
      }
    }
  }

  proccedWithCehcked() {
    const callback = [];
    if (this.grid && this.grid.rows) {
      for (let i = 0; i < this.grid.rows.length; i++) {
        if (this.grid.rows[i].selected) {
          const data = this.grid.rows[i];
          callback.push(data);
        }
      }
    }
    this.$emit("selectedExpenses", callback);
    this.dialog = false;
  }

  async mounted() {
    this.filter = {
      receiptNo: null,
      regNo: null,
      driverName: null,
      driverCC: null,
      driverPhone: null,
      fromDate: null,
      endDate: null,
    };
  }

  async showPage(page) {
    this.page = page;
    this.loading = true;
    this.grid = {};
    try {
      const data = await doPost(
        this.url + this.rows + this.filterUrl + "&page=" + page,
        { notinvalues: this.expenses }
      );

      for (let i = 0; i < data.rows.length; i++) {
        data.rows[i].selected = false;
      }
      this.grid = data;
      this.loading = false;
    } catch (e) {
      this.loading = false;
      common.showError(e.message);
    }
  }

  async clearSearch() {
    this.filter = {
      receiptNo: null,
      regNo: null,
      driverName: null,
      driverCC: null,
      driverPhone: null,
      startDate: null,
      endDate: null,
      supplier_id: null,
    };
    this.page = 1;
    this.search();
  }

  async search() {
    this.filter.supplier_id = this.supplier_id;
    this.filter.notBilled = this.notBilled;
    let filterUrl = "";
    if (this.filter.invoiceNo) filterUrl += "&invoice=" + this.filter.invoiceNo;
    if (this.filter.startDate)
      filterUrl += "&startDate=" + this.filter.startDate;
    if (this.filter.endDate) filterUrl += "&endDate=" + this.filter.endDate;
    if (this.filter.supplier_id)
      filterUrl += "&onBehalf=" + this.filter.supplier_id;
    if (this.filter.notBilled)
      filterUrl += "&notBilled=" + this.filter.notBilled;

    this.filterUrl = filterUrl;
    await this.showPage(1);
  }

  @Watch("dialog")
  async onDialogChange(val) {
    if (val) {
      try {
        this.search();
      } catch (e) {
        common.setError(e.message);
      }
    }
  }

  formatDate(date) {
    if (date) {
      const dateStr = date.toString();
      return (
        dateStr.substring(6, 8) +
        "-" +
        dateStr.substring(4, 6) +
        "-" +
        dateStr.substring(0, 4)
      );
    } else {
      return "";
    }
  }
}
</script>

<style scoped>
.pac-target-input {
  width: 50%;
  border: 1px solid #dfdfdf;
  height: 30px;
  padding: 10px 20px;
  z-index: 1;
  background: white;
  margin-left: 25%;
  position: absolute;
  margin-top: 10px;
}
.v-dialog > .v-card > .v-card__text {
  padding-top: 5px;
  padding-bottom: 5px;
}
.v-card .v-card__actions {
  padding-top: 5px;
  padding-bottom: 5px;
}
.v-dialog .v-card .v-card__title {
  padding-top: 10px;
}
</style>
